import { Input } from "@/components/ui/input";
import { Checkbox } from "@/components/ui/checkbox";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { AVAIL_STATUS, DAYS } from "@/lib/technicians";

export const AvailabilityEditor = ({ value, onChange }) => {
  const av = value || { status: "disponible", days: [], notes: "" };
  const dayOf = (i) => av.days.find((d) => d.day === i);
  const setDay = (i, patch) => {
    const cur = dayOf(i) || { day: i, enabled: false, start: "08:00", end: "18:00" };
    const days = [...av.days.filter((d) => d.day !== i), { ...cur, ...patch }].sort((a, b) => a.day - b.day);
    onChange({ ...av, days });
  };
  return (
    <div className="space-y-3" data-testid="availability-editor">
      <Select value={av.status} onValueChange={(v) => onChange({ ...av, status: v })}>
        <SelectTrigger data-testid="availability-status-select"><SelectValue /></SelectTrigger>
        <SelectContent>{Object.entries(AVAIL_STATUS).map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
      <div className="space-y-1.5">
        {DAYS.map((name, i) => {
          const d = dayOf(i);
          return (
            <div key={name} className="grid grid-cols-2 items-center gap-2 text-sm sm:grid-cols-[120px_1fr_1fr]">
              <label className="col-span-2 flex items-center gap-2 sm:col-span-1"><Checkbox checked={!!d?.enabled} onCheckedChange={(c) => setDay(i, { enabled: !!c })} data-testid={`availability-day-${i}`} />{name}</label>
              <Input type="time" className="h-9" disabled={!d?.enabled} value={d?.start || ""} onChange={(e) => setDay(i, { start: e.target.value })} data-testid={`availability-start-${i}`} />
              <Input type="time" className="h-9" disabled={!d?.enabled} value={d?.end || ""} onChange={(e) => setDay(i, { end: e.target.value })} data-testid={`availability-end-${i}`} />
            </div>
          );
        })}
      </div>
      <p className="text-xs text-muted-foreground">Si no marcas días, el técnico se considera disponible según su estado general (sin horario configurado).</p>
    </div>
  );
};
